/**
 * Check that the findAction has been set.
 * See state for more info.
 */
export function checkFindAction(state, action) {
  if (!state[action]) {
    throw new Error('findAction not declared');
  }
}


export default function dispatchFromParent(state, action, dispatch) {
  checkFindAction(state, action);
  dispatch(state[action], null, { root: true });
}
